import styled from 'styled-components'

export const Flex = styled.div`
    display: flex;
`

export const Button = styled.button`
    outline: none;
    border: none;
`